/// <reference types="@angular/localize" />

import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
if ('serviceWorker' in navigator && !localStorage.getItem('sw-updated')) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  }).then(() => {
    localStorage.setItem('sw-updated', 'true'); // نمنع التكرار

  });
}
window.addEventListener('load', () => {
  setTimeout(() => {
    localStorage.removeItem('sw-updated'); // يمسح العلامة بعد 10 ثواني مثلًا
  }, 10000);
});
